export function attachmentDisplayName(raw: string): string {
  let s = raw.trim();
  if (!s) return "Adjunto";
  if (/^https?:\/\//i.test(s)) {
    try {
      const path = new URL(s).pathname;
      const seg = path.split("/").filter(Boolean).pop();
      if (seg) s = decodeURIComponent(seg);
    } catch {
      s = s.replace(/^https?:\/\/[^/]+\//i, "");
    }
  }
  s = s.replace(/\\/g, "/");
  const base = s.split("/").pop() || s;
  const noQuery = base.split("?")[0] || base;
  const decoded = (() => {
    try {
      return decodeURIComponent(noQuery);
    } catch {
      return noQuery;
    }
  })();
  if (decoded.length > 44) return `${decoded.slice(0, 42)}…`;
  return decoded || "Adjunto";
}
